
// @flow


import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import useUserData from "../../hooks/user/useUserData";
import useUserAction from "../../hooks/user/useUserAction";
import useRoles from "../../modules/users/hooks/useRoles";
import {useTheme} from "@mui/material/styles";
import {Divider, Grid, Toolbar, Typography, useMediaQuery} from "@mui/material";
import axios from "axios";
import {API} from "../../helpers/constants";
import {handleAxiosErrors, logoutUnauthorizedUser} from "../../helpers/errorHandling";
import {enqueueSnackbar} from "notistack";
import {getRouteUrl} from "../../helpers/getRouteUrl";
import {ROUTE_PAGE_HOME} from "../../routers/routes";
import PermissionHOC from "../../modules/permission/components/permissionHOC/permissionHOC";
import Box from "@mui/material/Box";
import Breadcrumb from "../../components/breadcrumb/breadcrumb";
import HomeIcon from "@mui/icons-material/Home";
import {ROUTE_PAGE_USERS_INDEX} from "../../modules/users/routes/routes";
import Profile from "../../modules/users/components/profile/profile";
import ContentLoader from "../../components/contentLoader/contentLoader";
import {USERS} from "../../modules/users/locales/namespaces";
import MainCard from "../../theme/mantis/components/mainCard";
import HistoryLoginTable from "../../modules/users/components/Tables/HistoryLogin/historyLoginTable";

const ProfileDetails = () => {
    const {t} = useTranslation(USERS)
    const [loading, setLoading] = useState(false)
    const {id} = useParams()
    const [userData, setUserData] = useState({})
    const [open, setOpen] = useState(false);
    const {token, isLoggedIn,userId} = useUserData()
    const {userLogout} = useUserAction()
    const {roles} = useRoles()
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    const matchDownMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    useEffect(() => {
        setLoading(true)
        axios({
            method: 'post',
            data: {UserId: userId},
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
            url: `${API}/user/details/data`,
        }).then(response => {
            const data = response.data
            const user = data.user
            const roles = data.roles
            setUserData({
                ...user,
                isActive: user.isActive,
                CustId: user.CustId
            })
            setLoading(false)
        }).catch(error => {
            setLoading(false)
            enqueueSnackbar(handleAxiosErrors(error, t('Failed to get profile.')), {
                    variant: 'error'
                }
            )
            logoutUnauthorizedUser(error, isLoggedIn, userLogout)
        })
    }, [userId])

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    return !loading ? (
        <Box>
            <PermissionHOC requiredPermissions={['access_user_index']}>
                <Breadcrumb>
                    <Breadcrumb.Link iconComponent={HomeIcon} to={getRouteUrl(ROUTE_PAGE_HOME)}>
                        {t('Home Page')}
                    </Breadcrumb.Link>
                    <Breadcrumb.Link to={getRouteUrl(ROUTE_PAGE_USERS_INDEX)}>
                        {t('Users')}
                    </Breadcrumb.Link>
                    <Breadcrumb.Item>
                        {t('User Profile')}
                    </Breadcrumb.Item>
                </Breadcrumb>
            </PermissionHOC>
            <Toolbar disableGutters variant={"dense"}>
                <Grid container justifyContent="space-between" alignItems="center"
                      sx={{position: 'relative', zIndex: 5}}>
                    <Grid item>
                        <Typography variant="h4" gutterBottom>
                            {t('Profile')}
                        </Typography>
                    </Grid>
                </Grid>
            </Toolbar>
            <Divider sx={{mb: 2}} light/>
            <Box sx={!matchDownMD ? {display:'grid'}:{display:'grid'}}>
                <Box sx={!matchDownMD ? {width:'50%'}:{width:'100%'}}>
                    <Profile id={id} userData={userData}/>
                </Box>
                <Box sx={!matchDownMD ? {width:'100%'} : { width: '100%' }}>
                    <Divider light sx={{mt: 1}}/>
                    <MainCard  title={
                        <Toolbar disableGutters variant="dense">
                            <Typography variant="h5" gutterBottom>{t('Logs')}</Typography>
                        </Toolbar>
                    }>
                        <HistoryLoginTable/>
                    </MainCard>
                </Box>
            </Box>
        </Box>
    ) : (
        <ContentLoader
            loading={loading}
        />
    )
}

export default ProfileDetails